module.exports = __webpack_public_path__ + "static/media/manguera-gris.95adebee.svg";